<template>
  <div>
    <PageAllow controller="Settings" action="businessSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("easyPaySubAccount.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("easyPaySubAccount.application") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{ $t("easyPaySubAccount.application_title") }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("easyPaySubAccount.easypay_sub_account_enable") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group
                  row
                  v-model="settings.easypay_sub_account_enable"
                >
                  <v-radio :label="$t('Payment.off')" :key="0" :value="0" />
                  <v-radio :label="$t('Payment.on')" :key="1" :value="1" />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("miniDevelopProgram.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Setting from "@/api/settings";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.split"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-type",
      },
      {
        text: i18n.t("SettingNav.splitInterface"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-setting-port",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getEasyPayFromAPI();
  },
  methods: {
    getEasyPayFromAPI() {
      Setting.settings("keys[]=easypay_sub_account_enable").then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (this.settings.easypay_sub_account_enable == null) {
              this.settings.easypay_sub_account_enable = 0;
            }
          }
        }.bind(this)
      );
    },

    save() {
      delete this.settings.distribution_district_unique_enable;
      const arr = [];
      for (let key in this.settings) {
        arr.push({ setting_key: key, setting_value: this.settings[key] });
      }
      Setting.batchSave(arr).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.replace(
              "/settings/sub-account-settings/sub-account-setting-port"
            );
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>